import ResetPasswordPage from '@/pages/ResetPassword';
import { createLazyFileRoute } from '@tanstack/react-router';

export const Route = createLazyFileRoute('/reset-password/')({
  component: ResetPasswordPage,
});
